import { baseApi } from "./baseApi";
import * as API from "@utils/apiPath";
import type { ApiResponse, ValuesInterface } from "interface/vehicleType";
import { StatusInterface } from "interface/common";

export const vehicleTypeApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getVehicleTypes: builder.query<ApiResponse, { [key: string]: string | number }>({
      query: (params) => ({
        url: API.GET_VEHICLE_TYPE,
        method: "GET",
        params,
      }),
      providesTags: ["VehicleType"],
    }),
    getVehicleTypeList: builder.query<
      ApiResponse,
      { [key: string]: string | number } | void
    >({
      query: (params) => ({
        url: API.GET_VEHICLE_TYPE_LIST,
        method: "GET",
        params: params || undefined,
      }),
      providesTags: ["VehicleType"],
    }),
    createVehicleType: builder.mutation<
      ApiResponse,
      { params: ValuesInterface; onClose: () => void }
    >({
      query: ({ params }) => ({
        url: API.GET_VEHICLE_TYPE,
        method: "POST",
        body: params,
      }),
      invalidatesTags: ["VehicleType"],
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
          arg.onClose();
        } catch (error) {
          console.error("Failed to create vehicle type:", error);
        }
      },
    }),
    updateVehicleType: builder.mutation<
      ApiResponse,
      { params: ValuesInterface; onClose: () => void }
    >({
      query: ({ params }) => ({
        url: API.GET_VEHICLE_TYPE,
        method: "PUT",
        body: params,
      }),
      invalidatesTags: ["VehicleType"],
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
          arg.onClose();
        } catch (error) {
          console.error("Failed to update vehicle type:", error);
        }
      },
    }),
    updateVehicleTypeStatus: builder.mutation<ApiResponse, StatusInterface>({
      query: ({ id, ...body }) => ({
        url: `/${API.GET_VEHICLE_TYPE}/status/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["VehicleType"],
    }),
    deleteVehicleType: builder.mutation<ApiResponse, string>({
      query: (id) => ({
        url: `/${API.GET_VEHICLE_TYPE}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["VehicleType"],
    }),
    bulkUpdateVehicleTypeStatus: builder.mutation<
      ApiResponse,
      { ids: string[]; status: boolean }
    >({
      query: ({ ids, status }) => ({
        url: `/${API.GET_VEHICLE_TYPE}/bulk-status`,
        method: "PUT",
        body: { ids, status },
      }),
      invalidatesTags: ["VehicleType"],
    }),
    bulkDeleteVehicleTypes: builder.mutation<ApiResponse, { ids: string[] }>({
      query: ({ ids }) => ({
        url: `/${API.GET_VEHICLE_TYPE}/bulk-delete`,
        method: "DELETE",
        body: { ids },
      }),
      invalidatesTags: ["VehicleType"],
    }),
  }),
});

export const {
  useGetVehicleTypesQuery,
  useGetVehicleTypeListQuery,
  useCreateVehicleTypeMutation,
  useUpdateVehicleTypeMutation,
  useUpdateVehicleTypeStatusMutation,
  useDeleteVehicleTypeMutation,
  useBulkUpdateVehicleTypeStatusMutation,
  useBulkDeleteVehicleTypesMutation,
} = vehicleTypeApi;
